import { useDatasourceLoader, LoadOutcome } from "./useDatasourceLoader";
import { Estimate } from "../../interfaces/Estimate";

export function useEstimateLoader() {
  const { loadDatasources } = useDatasourceLoader();

  const loadEstimate = (estimate: Estimate): Promise<LoadOutcome> => loadDatasources([{ type: "estimate", estimate }]);

  return { loadEstimate };
}
